export default "__VITE_ASSET__DU2haeng__"